module.exports = __webpack_public_path__ + "static/media/target_lv_15e531c22e555922b7e93d80be607c8ca.webp";